<template>
    <div class="row">
        <div class="col-12 mb-1">
            <table class="table table-bordered table-sm mb-0">
                <tbody>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Başlangıç Bölgesi</td>
                        <td class="w-50">{{ $safe(value,'StartRegionName') }}</td>
                    </tr>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Bitiş Bölgesi</td>
                        <td class="w-50">{{ $safe(value,'EndRegionName') }}</td>
                    </tr>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Araç Tipi</td>
                        <td class="w-50">{{ $safe(value,'VehicleTypeName') }}</td>
                    </tr>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Ürün Tipi</td>
                        <td class="w-50">{{ $safe(value,'StockName') }}</td>
                    </tr>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Taşıma Tipi</td>
                        <td class="w-50">{{ $safe(value,'StatusStr') }}</td>
                    </tr>
                    <tr>
                        <td class="w-50 font-weight-bolder bg-light">Son Güncelleme Tarihi</td>
                        <td class="w-50">{{ $safe(value,'StartDate') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12 mb-50">
            <h5 class="mb-0 text-muted text-right">Güncel Fiyat: <b class="text-secondary">{{ $safe(value,'PriceStr') }}₺</b></h5>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yeni Fiyat</label>
            <v-currency-input input-class="text-right" :value="value.NewPrice" v-on:update-value="currencyAmount => value.NewPrice = currencyAmount"></v-currency-input>
        </div>

        <!-- Düzeltme mi, yeni pazarlık mı? İkisinin mazot baz'ına etkisi birbirinin tersi
             olduğu için kullanıcıdan açıkça seçmesi isteniyor. -->
        <div class="col-12 mb-1">
            <button class="btn btn-sm btn-flat-primary p-0" v-on:click="showHelp = !showHelp">
                <feather-icon icon="HelpCircleIcon" size="14" class="mr-25"></feather-icon>
                Nasıl çalışır?
                <feather-icon :icon="showHelp ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="12"></feather-icon>
            </button>
            <div v-if="showHelp" class="border rounded p-1 mt-50 bg-light">
                <small>
                    <b>Neden iki tür değişiklik var?</b><br>
                    Bir fiyatın değişmesinin iki sebebi olabilir ve ikisinin mazot hesabına etkisi
                    birbirinin tersidir. Yanlış seçim, ya zam kaybına ya çifte zamma yol açar.
                    <div class="table-responsive mt-50">
                        <table class="table table-sm table-bordered bg-white mb-0">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">Düzeltme</th>
                                    <th class="text-nowrap">Yeni pazarlık</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="font-weight-bolder">Ne zaman</td>
                                    <td>Fiyat yanlış girilmişti</td>
                                    <td>Nakliyeciyle yeni fiyatta anlaşıldı</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Fiyat ne zaman geçerli</td>
                                    <td>Bugünden</td>
                                    <td>Seçtiğiniz baz tarihten</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Mazot baz'ı</td>
                                    <td>Korunur, birikmiş fark durur</td>
                                    <td>Seçtiğiniz güne taşınır, birikim sıfırlanır</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Geçmiş fiyat kaydı</td>
                                    <td class="text-success">Tamamen korunur</td>
                                    <td class="text-danger">Baz tarihten sonrakiler silinir</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Geçmiş sefer maliyeti</td>
                                    <td class="text-success">Değişmez</td>
                                    <td class="text-danger">Baz tarihten sonrası yeniden fiyatlanır</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr class="my-50">

                    <b>Düzeltme güvenli olandır.</b> Geçmişe hiç dokunmaz. Baz korunduğu için
                    düzelttiğiniz fiyatın üstüne, mazot eşiği aşıldığında gece servisinde zam
                    gelebilir — birikim korunuyor demek budur.
                    <hr class="my-50">

                    <b>Yeni pazarlıkta baz tarih geçmişte ise</b><br>
                    Fiyat o günden itibaren yazılır, aradaki mazot hareketleri ara zam olarak
                    üretilir ve o pencerede kalan eski fiyat versiyonları silinir. Baz tarih
                    bugünse ara zam oluşmaz, geçmiş de etkilenmez.
                    <hr class="my-50">

                    <b>Gerekçe alanı</b><br>
                    Zorunlu değil ama doldurun: bu değişikliğin <u>neden</u> yapıldığının kaydı
                    şimdilik yalnızca orada tutuluyor.
                </small>
            </div>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">Değişikliğin Türü</label>
            <b-form-radio-group v-model="changeKind" stacked>
                <b-form-radio value="correction">
                    Düzeltme
                    <small class="d-block text-muted">
                        Fiyat yanlış girilmişti. Mazot baz tarihi korunur, rotanın birikmiş
                        mazot farkı kaybolmaz.
                    </small>
                </b-form-radio>
                <b-form-radio value="renegotiation">
                    Yeni pazarlık
                    <small class="d-block text-muted">
                        Nakliyeciyle yeni fiyatta anlaşıldı. Mazot baz tarihi seçtiğiniz güne
                        taşınır, yeni fiyatın üstüne eski birikim tekrar binmez.
                    </small>
                </b-form-radio>
            </b-form-radio-group>
        </div>

        <div class="col-12 mb-1" v-if="changeKind === 'renegotiation'">
            <label class="form-label">Yeni Mazot Baz Tarihi <span class="text-danger">*</span></label>
            <v-select-list
                v-model="fuelBase"
                placeholder="Baz tarih ve mazot fiyatı seçiniz"
                label="Label"
                :loading="fuelPricesLoading"
                :options="fuelPrices"/>
            <small v-if="!value.FuelBaseDate" class="text-danger">
                Yeni pazarlıkta baz tarih seçilmelidir.
            </small>
        </div>

        <div class="col-12">
            <label class="form-label">Gerekçe <small class="text-muted">(opsiyonel)</small></label>
            <input type="text" class="form-control" v-model="value.ChangeNote" placeholder="Ör: Nakliyeci pazarlığı sonrası sabitleme" />
        </div>
    </div>
</template>
<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormRadio, BFormRadioGroup } from 'bootstrap-vue'
import { FuelPriceApi } from '@/api/fuel-price'
import moment from 'moment'

export default{
    components:{
        VCurrencyInput,
        BFormRadio,
        BFormRadioGroup
    },
    props:{
        value:Object
    },
    data(){
        return {
            fuelPrices:[],
            fuelPricesLoading:false,
            showHelp:false
        }
    },
    mounted(){
        this.getFuelPrices()
    },
    methods:{
        getFuelPrices(){
            this.fuelPricesLoading = true
            FuelPriceApi.List().then(res=>{
                this.fuelPrices = res.data.Data || []
                this.fuelPricesLoading = false
            }).catch(err=>{
                console.error(err)
                this.fuelPricesLoading = false
            })
        }
    },
    computed:{
        // Düzeltmede sunucuya baz tarih gönderilmez; bu da "baz'ı koru" anlamına gelir.
        changeKind:{
            get:function(){
                return this.value.ChangeKind || 'correction'
            },
            set:function(kind){
                this.$set(this.value,'ChangeKind',kind)
                if(kind === 'correction')
                    this.$set(this.value,'FuelBaseDate',null)
            }
        },
        fuelBase:{
            get:function(){
                if(!this.value.FuelBaseDate)
                    return null
                return this.fuelPrices.find(f => moment(f.Date).isSame(moment(this.value.FuelBaseDate),'day')) || null
            },
            set:function(value){
                this.$set(this.value,'FuelBaseDate', value == null ? null : moment(value.Date).format('YYYY-MM-DD'))
            }
        }
    }
}
</script>